import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";
import { motion } from "framer-motion";
import { sendUserData } from "../../services/api";
import { useAuraVoice } from "../../hooks/useAuraVoice";
import "./Processing.css";

import Stars from "../../assets/stars.svg";
import Logo from "../../assets/logo.svg";

const Processing = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  useAuraVoice("Hmm... deixa eu pensar aqui sobre o seu desafio...", "reflection");

  const hasFetched = useRef(false);

  useEffect(() => {
    const executeTask = async () => {
      if (hasFetched.current) {
        return;
      }
      hasFetched.current = true;

      try {
        const userData = {
          user: state.user,
          company_context: state.userContext,
        };

        dispatch({ type: "UPDATE_STATE", payload: { isLoading: true } });

        const response = await sendUserData(userData);

        dispatch({ type: "FIRST_DRAFT_RESPONSE", payload: response });

        navigate("/validation");
      } catch (error) {
        console.error("Erro ao validar desafio:", error);

        dispatch({
          type: "UPDATE_STATE",
          payload: {
            isLoading: false,
            error: "Falha ao processar a solicitação.",
          },
        });

        navigate("/");
      }
    };

    executeTask();
  }, [navigate, dispatch, state.user, state.userContext]);

  return (
    <motion.div
              className="processing-container"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
      <img src={Stars} alt="Estrelas no céu" className="stars-background" />
      <div className="processing-content">
        <img src={Logo} alt="Logo" className="spinner-logo" />
        <p>Refletindo sobre seu desafio...</p>
      </div>
    </motion.div>
  );
};

export default Processing;
